// Gestor de efectos re-inicializable: se llama tras cada render() del motor.
let cleanups = [];
const reduced = () => window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

function initStars(canvas) {
  const ctx = canvas.getContext('2d', { willReadFrequently: true });
  let w, h, stars, raf, mx = 0, my = 0;
  const resize = () => {
    const r = canvas.getBoundingClientRect();
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    w = canvas.width = Math.max(1, r.width * dpr);
    h = canvas.height = Math.max(1, r.height * dpr);
    const n = Math.round((r.width * r.height) / 9000);
    stars = Array.from({ length: Math.min(n, 150) }, () => ({
      x: Math.random() * w, y: Math.random() * h,
      r: (Math.random() * 1.3 + 0.3) * dpr,
      a: Math.random(), s: Math.random() * 0.02 + 0.004,
      dx: (Math.random() - 0.5) * 0.12 * dpr, dy: (Math.random() - 0.5) * 0.12 * dpr,
    }));
  };
  const onMove = (e) => { mx = (e.clientX / window.innerWidth - 0.5); my = (e.clientY / window.innerHeight - 0.5); };
  const draw = () => {
    ctx.clearRect(0, 0, w, h);
    for (const st of stars) {
      st.a += st.s; const tw = 0.55 + 0.45 * Math.sin(st.a);
      st.x += st.dx; st.y += st.dy;
      if (st.x < 0) st.x = w; if (st.x > w) st.x = 0;
      if (st.y < 0) st.y = h; if (st.y > h) st.y = 0;
      const px = st.x - mx * 18, py = st.y - my * 18;
      ctx.beginPath();
      ctx.fillStyle = `rgba(228,205,150,${(0.25 + tw * 0.6).toFixed(3)})`;
      ctx.arc(px, py, st.r, 0, Math.PI * 2); ctx.fill();
    }
    raf = requestAnimationFrame(draw);
  };
  resize();
  if (reduced()) { draw(); cancelAnimationFrame(raf); } else { draw(); }
  window.addEventListener('resize', resize);
  if (!reduced()) window.addEventListener('pointermove', onMove);
  const onVis = () => { if (document.hidden) cancelAnimationFrame(raf); else if (!reduced()) raf = requestAnimationFrame(draw); };
  document.addEventListener('visibilitychange', onVis);
  cleanups.push(() => {
    cancelAnimationFrame(raf);
    window.removeEventListener('resize', resize);
    window.removeEventListener('pointermove', onMove);
    document.removeEventListener('visibilitychange', onVis);
  });
}

function initFan(fan) {
  const cards = [...fan.querySelectorAll('.fcard')];
  const n = cards.length;
  cards.forEach((c, i) => {
    const spread = 14; // grados por carta
    const rot = (i - (n - 1) / 2) * spread;
    c.style.setProperty('--rot', rot + 'deg');
    c.style.zIndex = String(i);
  });
}

function initCounters(root) {
  const els = root.querySelectorAll('[data-count]');
  if (!els.length) return;
  const run = (el) => {
    const target = parseFloat(el.getAttribute('data-count')) || 0;
    const dec = (el.getAttribute('data-count').indexOf('.') > -1) ? 1 : 0;
    if (reduced()) { el.textContent = target.toFixed(dec); return; }
    const dur = 900, t0 = performance.now();
    const step = (t) => {
      const p = Math.min(1, (t - t0) / dur);
      const e = 1 - Math.pow(1 - p, 3);
      el.textContent = (target * e).toFixed(dec);
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };
  const io = new IntersectionObserver((entries) => {
    entries.forEach((en) => { if (en.isIntersecting) { run(en.target); io.unobserve(en.target); } });
  }, { threshold: 0.4 });
  els.forEach((el) => io.observe(el));
  cleanups.push(() => io.disconnect());
}

function initPath(root) {
  const sec = root.querySelector('#como');
  const rail = root.querySelector('#como .path-rail');
  if (!sec || !rail) return;
  const fill = rail.querySelector('.path-fill');
  const light = rail.querySelector('.path-light');
  const steps = [...sec.querySelectorAll('.steps .step')];
  let ticking = false;
  const compute = () => {
    ticking = false;
    const r = sec.getBoundingClientRect();
    const vh = window.innerHeight || document.documentElement.clientHeight;
    const line = vh * 0.62;
    let p = (line - r.top) / (r.height * 0.82);
    p = Math.max(0, Math.min(1, p));
    fill.style.width = (p * 100).toFixed(1) + '%';
    light.style.left = (p * 100).toFixed(1) + '%';
    light.style.opacity = (p > 0.01 && p < 0.995) ? '1' : '0';
    steps.forEach((st, i) => st.classList.toggle('lit', p >= (i / steps.length) * 0.92));
  };
  const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(compute); } };
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  compute();
  cleanups.push(() => {
    window.removeEventListener('scroll', onScroll);
    window.removeEventListener('resize', onScroll);
  });
}

function initTilt(root) {
  if (reduced() || !(window.matchMedia && window.matchMedia('(pointer: fine)').matches)) return;
  const els = [...root.querySelectorAll('[data-tilt]')];
  els.forEach((el) => {
    const max = parseFloat(el.getAttribute('data-tilt')) || 6;
    const move = (e) => {
      const r = el.getBoundingClientRect();
      const px = (e.clientX - r.left) / r.width - 0.5;
      const py = (e.clientY - r.top) / r.height - 0.5;
      el.style.transform = `perspective(800px) rotateY(${(px * max).toFixed(2)}deg) rotateX(${(-py * max).toFixed(2)}deg) translateY(-6px)`;
    };
    const leave = () => { el.style.transform = ''; };
    el.addEventListener('pointermove', move);
    el.addEventListener('pointerleave', leave);
    cleanups.push(() => { el.removeEventListener('pointermove', move); el.removeEventListener('pointerleave', leave); });
  });
}

export function mountEffects(root) {
  cleanups.forEach((fn) => { try { fn(); } catch (e) {} });
  cleanups = [];
  if (!root) return;
  const canvas = root.querySelector('.hero-stars');
  if (canvas) initStars(canvas);
  const fan = root.querySelector('.fan');
  if (fan) initFan(fan);
  initPath(root);
  initTilt(root);
  initCounters(root);
}
